import { useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleRight } from "@fortawesome/free-solid-svg-icons";

const Dropdown = (props) => {
  const {pathname}=useLocation()
  const dropdowns = props.dropdownLinks.map((subLink) => (
    <li
    onClick={props.toggleSideBar}
      key={subLink.name}
      className={`bg-gray-800 p-2 hover:text-yellow-500 z-50 ${pathname.includes(subLink.url)?"text-yellow-900":"text-white"}`}
    >
      <Link to={subLink.url}>
        {" "}
        {subLink.name}{" "}
        <FontAwesomeIcon icon={faArrowAltCircleRight} size="sm" />
      </Link>
    </li>
  ));
  return (
    <>
   {props.toggle && props.index===props.myIndex && 
     <ul className="static transition 4s">
   <motion.div
             initial={{ y: "-100%" }}
             animate={{ y: 0 }}
             exit={{ y: "-100%" }}
             transition={{ duration: 0.3 }}
             className="pb-0 z-50"
           >
    
      {dropdowns}
    </motion.div>
    </ul>
   }
   </>
  );
};

export default Dropdown;
